var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExchangeAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "gnlx22qj4a",
    d: "M0 7.876v-.75c0-.621.504-1.125 1.125-1.125H18v-2.25c0-1.001 1.214-1.502 1.92-.795l3.75 3.75c.44.439.44 1.151 0 1.59l-3.75 3.75c-.703.704-1.92.21-1.92-.795v-2.25H1.125C.504 9.001 0 8.497 0 7.876zm22.875 7.125H6v-2.25c0-.999-1.212-1.504-1.92-.795l-3.75 3.75c-.44.439-.44 1.151 0 1.59l3.75 3.75c.704.705 1.92.21 1.92-.795v-2.25h16.875c.621 0 1.125-.504 1.125-1.125v-.75c0-.621-.504-1.125-1.125-1.125z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchangeAlt);
export default __webpack_public_path__ + "static/media/exchange-alt.45dcebb99d6503bb5c1e2842e356cac3.svg";
export { ForwardRef as ReactComponent };